// import React, { useEffect, useState } from "react";
// import { Box, Button, TextField } from "@mui/material";
// import { useField } from "formik";

// interface NumberInputProps {
//   name: string;
//   setFieldValue: any;
//   formValues: any;
//   addon?: boolean;
//   addonid?: string;
//   priceObject: any;
//   bookingMemberTypes: any[]
// }

// const NumberInput: React.FC<NumberInputProps> = ({
//   name,
//   setFieldValue,
//   formValues,
//   addon = false,
//   addonid,
//   priceObject,
//   bookingMemberTypes
// }) => {
//   const [field] = useField(name);
//   const [defaultValue, setDefaultValue] = useState<number>(formValues.bookingMemberTypes ? formValues.bookingMemberTypes[field.name] ?? 0 : 0);

//   useEffect(() => {
//     setDefaultValue(formValues.bookingMemberTypes ? formValues.bookingMemberTypes[field.name] ?? 0 : 0);
//   }, [formValues.bookingMemberTypes])
//   const handleIncrement = () => {
//     setDefaultValue((prev) => {
//       if (addon) {
//         setFieldValue(`${addonid}::bookingMemberTypes`, {
//           ...formValues[`${addonid}::bookingMemberTypes`],
//           [field.name]: prev + 1,
//         });
//       } else {
//         setFieldValue("bookingMemberTypes", {
//           ...formValues?.bookingMemberTypes,
//           [field.name]: prev + 1,
//           ...(priceObject.dependsid ? { [priceObject.dependsid]: (formValues.bookingMemberTypes ? (formValues.bookingMemberTypes[priceObject.dependsid]) : 0) + 1 } : {}),
//         });
//       }
//       return prev + 1;
//     });
//   };

//   const handleDecrement = () => {
//     setDefaultValue((prev) => {
//       if (addon) {
//         setFieldValue(`${addonid}::bookingMemberTypes`, {
//           ...formValues[`${addonid}::bookingMemberTypes`],
//           [field.name]: Math.max(prev - 1, 0),
//         });
//       } else {
//         setFieldValue("bookingMemberTypes", {
//           ...formValues?.bookingMemberTypes,
//           [field.name]: Math.max(prev - 1, 0),
//           ...(priceObject.dependsid ? { [priceObject.dependsid]: Math.max((formValues.bookingMemberTypes ? (formValues.bookingMemberTypes[priceObject.dependsid] ?? 0) : 0) - 1, 0) } : {}),
//         });
//         // setTimeout(() => {
//           const dependsDataId = bookingMemberTypes?.filter((member: any) => member.dependsid === field.name);
//           for (let i = 0; i < dependsDataId.length; i++) {
//             const dependsData = dependsDataId[i];
//             console.log(dependsData, "ayush cghecking ")
//             setFieldValue("bookingMemberTypes", (prev: any) => { console.log(prev);  return prev});
//           }
//         // }, 1000);
//       }
//       return Math.max(prev - 1, 0);
//     });
//   };

//   // console.log(formValues?.bookingMemberTypes, "assasa")
//   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const newValue = parseInt(event.target.value, 10);
//     if (addon) {
//       setFieldValue(`${addonid}::bookingMemberTypes`, {
//         ...formValues[`${addonid}::bookingMemberTypes`],
//         [field.name]: isNaN(newValue) ? 0 : newValue,
//       });
//     } else {
//       setFieldValue("bookingMemberTypes", {
//         ...formValues?.bookingMemberTypes,
//         [field.name]: isNaN(newValue) ? 0 : newValue,
//       });
//     }
//   };

//   return (
//     <Box display="flex" alignItems="center">
//       <Button
//         variant="contained"
//         onClick={handleDecrement}
//         disabled={defaultValue === 0}
//         sx={{ minWidth: 30, padding: 0.5, height: 30 }}
//       >
//         -
//       </Button>
//       <TextField
//         type="number"
//         {...field}
//         onChange={handleChange}
//         inputProps={{
//           style: {
//             textAlign: "center",
//             height: 0,
//             border: "none",
//             borderBottom: "1px solid black",
//           },
//           min: 0,
//         }}
//         sx={{
//           mx: 2,
//           width: 70,
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": {
//               border: "none",
//             },
//           },
//           "& .MuiInputBase-root": {
//             height: 30,
//             "&::before, &::after": {
//               border: "none",
//             },
//           },
//         }}
//         value={
//           !addon
//             ? (formValues?.bookingMemberTypes && formValues?.bookingMemberTypes[field.name]) || 0
//             : (formValues[`${addonid}::bookingMemberTypes`] &&
//               formValues[`${addonid}::bookingMemberTypes`][field.name]) ||
//             0
//         }
//       />
//       <Button
//         variant="contained"
//         onClick={handleIncrement}
//         sx={{ minWidth: 30, padding: 0.5, height: 30 }}
//       >
//         +
//       </Button>
//     </Box>
//   );
// };

// export default NumberInput;

import React, { useReducer, useEffect } from "react";
import { Box, Button, TextField } from "@mui/material";
import { useField } from "formik";
import './style.css'

interface NumberInputProps {
  name: string;
  setFieldValue: any;
  formValues: any;
  addon?: boolean;
  addonid?: string;
  priceObject: any;
  bookingMemberTypes: any[];
}

const initialState = {
  value: 0,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case 'increment':
    case 'decrement':
      return { ...state, value: action.payload };
    case 'set':
      return { ...state, value: action.payload };
    default:
      throw new Error();
  }
}

const NumberInput: React.FC<NumberInputProps> = ({
  name,
  setFieldValue,
  formValues,
  addon = false,
  addonid,
  priceObject,
  bookingMemberTypes
}) => {
  const [field] = useField(name);
  const [state, dispatch] = useReducer(reducer, initialState, init => ({
    ...init, value: formValues.bookingMemberTypes ? formValues.bookingMemberTypes[field.name] ?? 0 : 0
  }));

  useEffect(() => {
    dispatch({ type: 'set', payload: formValues.bookingMemberTypes ? formValues.bookingMemberTypes[field.name] ?? 0 : 0 });
    if (field.name && priceObject.dependsid && formValues.bookingMemberTypes && formValues.bookingMemberTypes[field.name] && formValues.bookingMemberTypes[priceObject.dependsid]) {
      setFieldValue("dependsValueFeature", { ...formValues.dependsValueFeature, [field.name]: { "children": field.name, "parent": priceObject.dependsid } })
    }
  }, [formValues.bookingMemberTypes, field.name]);

  const handleIncrement = () => {
    const newValue = state.value + 1;
    const updateObject = addon ? `${addonid}::bookingMemberTypes` : "bookingMemberTypes";
    const newState = {
      ...formValues[updateObject],
      [field.name]: newValue,
    };
    if (field.name && priceObject.dependsid) {
      setFieldValue("dependsValueFeature", { ...formValues.dependsValueFeature, [field.name]: { "children": field.name, "parent": priceObject.dependsid } })
    }
    setFieldValue(updateObject, newState);
    dispatch({ type: 'increment', payload: newValue });
  };

  const handleDecrement = () => {
    const newValue = Math.max(state.value - 1, 0);
    const updateObject = addon ? `${addonid}::bookingMemberTypes` : "bookingMemberTypes";
    const newState = {
      ...formValues[updateObject],
      [field.name]: newValue,
    };
    setFieldValue(updateObject, newState);
    dispatch({ type: 'decrement', payload: newValue });
  };

  return (
    <Box display="flex" alignItems="center" className="ticket-action-wrapper">
      <Button
        variant="outlined"
        onClick={handleDecrement}
        sx={{ minWidth: 30, color: "black", height: 36, borderRight: '1px solid black', borderColor: "black", borderRadius: 0 }}
      >
        -
      </Button>
      <div className="ticket-counter">
        {
          state.value
        }
      </div>
      <Button
        variant="outlined"
        onClick={handleIncrement}
        sx={{ minWidth: 30, height: 36, borderRight: '1px solid black', borderColor: "black", borderRadius: 0, color: "black" }}
      >
        +
      </Button>
    </Box>
  );
};

export default NumberInput;
